import React, { useState, useEffect } from 'react';
import './Sport-Info.css';
import Schedule from '../Sport-Schedule/Schedule';

function SportInfo() {
    const [progress, setProgress] = useState(0);
    const [firstUser, setFirstUser] = useState(null);
    const [sportHours, setSportHours] = useState(0);

    useEffect(() => {
        const percentage = Math.min((sportHours / 30) * 100, 100);
        setProgress(percentage);

        const fetchFirstUser = async () => {
            try {
                const response = await fetch('http://localhost:5000/api/Sport/GetAllUsers');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                const user = data[0];
                setFirstUser(user);
                setSportHours(user.sportHours || 0);
                console.log("user_data: ", user);
            } catch (error) {
                console.error('Failed to fetch first user:', error);
            }
        };

        fetchFirstUser();
    }, [sportHours]);

    return (
        <main className="schedule bg-light-background dark:bg-dark-background p-16">
            {firstUser && (
                <div className="user-info">
                    <h2 className="user-name category-title-font">{firstUser.firstNameEn} {firstUser.lastNameEn}</h2>
                    <p className="user-email">{firstUser.email}</p>
                </div>
            )}

            <h2 className="category-title-font mt-11 mb-10">Current sport hours</h2>
            <div className="flex flex-row">
                <div className="w-1/3 h-10 mb-4 bg-gray-200 rounded-full dark:bg-gray-700 shadow-element overflow-hidden">
                    <div
                        className="h-10 bg-light-accent rounded-l-full dark:bg-dark-hoveredAccent"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
                <span id="progressText" className="category-title-font ml-3 mt-1.5">
                    {sportHours}/30
                </span>
            </div>
            <Schedule />
        </main>
    );
}

export default SportInfo;
